var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-button',{staticClass:"ld-button",class:[_vm.size ? 'ld-button-' + _vm.size : '',
           _vm.main ? 'main linear-main1' : '', 
           _vm.main2 ? 'main2 linear-main2' : '',
           _vm.main3 ? 'main3 bg-main' : '',
           _vm.main4 ? 'main4 linear-main4' : '',
           _vm.round ? 'round' : '', 
           _vm.light ? 'light' : '', 
           _vm.plain ? 'plain' : '', 
           _vm.gray ? 'gray' : '',
           _vm.defaults ? 'default' : '',
           _vm.transparent?'transparent':'',
           _vm.orangeRed?'orangeRed':'',
           _vm.blue?'blue':'' ],attrs:{"type":_vm.type,"url":_vm.url,"icon":_vm.icon,"loading":_vm.loading,"disabled":_vm.disabled,"hairline":_vm.hairline,"tag":_vm.tag,"block":_vm.block,"loading-text":_vm.loadingText,"loading-type":_vm.loadingType,"loading-size":_vm.loadingSize,"to":_vm.to,"replace":_vm.replace},on:{"click":_vm.handleClick,"touchstart":_vm.touchStart}},[_vm._t("default"),(_vm.help)?_c('p',[_vm._t("help")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }